import { Container, Row, Col } from 'react-bootstrap';
import styled from "styled-components"

import { BPSArrowLink, Arrow } from '../styled/Buttons';

import BlogIcon from '../../assets/icons/BPS Icon - Blog.png';
import TalkIcon from '../../assets/icons/BPS Icon - Talk to us.png';
import FAQIcon from '../../assets/icons/BPS Icon - FAQ.png';

import '../GlobalStyle.css';

const CTACard = styled.div`
    
    div {
        font-weight: bold;
        color: #1c304c !important;
        font-size: 1.25rem;
        }

`


const CTA = () => {
    return (
        <>
            <Container fluid className='py-5 text-center'>
                <Row className='justify-content-center'>
                    <Col xxl={4} lg={6} xl={5}>
                        <h4 className='fs-48 pb-5'>Get expert answers to all your questions</h4>
                    </Col>
                </Row>
                <Row className='justify-content-evenly pb-5'>
                    <Col md={4} xxl={3} className='py-4'>
                        <CTACard>
                            <img src={BlogIcon} width={60} alt='knowledge center' />
                            <div>Explore our Knowledge Center</div>
                            <p>Delve into the world of incentives and their transformative benefits with our articles.</p>

                            <BPSArrowLink href='/knowledge-center' className='fs-18'>View our articles <Arrow /></BPSArrowLink>
                        </CTACard>
                    </Col>
                    <Col md={4} xxl={4} className='py-4'>
                        <CTACard>
                            <img src={TalkIcon} width={60} alt='contact us' />
                            <div>Talk to us</div>
                            <p>Have a question or want a demo? Reach out to our team Monday - Friday, 8am - 4pm PST.</p>
                            <Row className='justify-content-center'>
                                <Col xl={6}>
                                    <BPSArrowLink href='/schedule-demo' className='fs-18'>Send a message<Arrow /></BPSArrowLink>
                                </Col>
                                <Col xl={6}>
                                    <span className='fs-18 color-sky'>800-371-6801</span>
                                </Col>
                            </Row>
                        </CTACard>
                    </Col>
                    <Col md={4} xxl={3} className='py-4'>
                        <CTACard>
                            <img src={FAQIcon} width={60} alt='faq' />
                            <div>Browse our FAQs</div>
                            <p>Get quick answers to common incentive questions with our collection of frequently asked questions.</p>

                            <BPSArrowLink href='/faqs' className='fs-18'>View FAQs <Arrow /></BPSArrowLink>
                        </CTACard>
                    </Col>
                </Row>
            </Container >
        </>
    );
}

const CTAContact = () => {
    return (
        <>
            <Container fluid className='py-5 text-center'>
                <Row className='justify-content-center'>
                    <Col lg={6} xl={5}>
                        <h4 className='fs-48 pb-5'>Get expert answers to all your questions</h4>
                    </Col>
                </Row>
                <Row className='justify-content-evenly pb-5'>
                    <Col md={4} xxl={3} className='py-4'>
                        <CTACard>
                            <img src={BlogIcon} width={60} alt='knowledge center' />
                            <div>Explore our Knowledge Center</div>
                            <p>Delve into the world of incentives and their transformative benefits with our articles.</p>

                            <BPSArrowLink href='/knowledge-center' className='fs-18'>View our articles <Arrow /></BPSArrowLink>
                        </CTACard>
                    </Col>
                    <Col md={4} xxl={3} className='py-4'>
                        <CTACard>
                            <img src={FAQIcon} width={60} alt='faq' />
                            <div>Browse our FAQs</div>
                            <p>Get quick answers to common incentive questions with our collection of frequently asked questions.</p>

                            <BPSArrowLink href='/faqs' className='fs-18'>View FAQs <Arrow /></BPSArrowLink>
                        </CTACard>
                    </Col>
                    <Col md={4} xxl={3} className='py-4'>
                        <CTACard>
                            <img src={TalkIcon} width={60} alt='faq' />
                            <div>Program assistance</div>
                            <p>Looking for help with an existing program? Our customer service team is available Monday - Friday, 8am - 4pm PST.</p>
                        </CTACard>
                    </Col>
                </Row>
            </Container >
        </>
    );
}

export { CTA, CTAContact }